module.exports = __webpack_public_path__ + "img/reelables-name-logo.8c3454f4.svg";